<template>
  <div class="card">
    <h1>
      Website In Progress
    </h1>
  </div>
</template>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 1rem;
  margin: 2rem auto;
  max-width: 40rem;
}
h1 {
  text-align: center;
  color: brown;
}
</style>
